// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__17Ivd","Top":"Main_Top__1RauX","Label":"Main_Label__EKQlK","Greet":"Main_Greet__1F4m3","Offer":"Main_Offer__RXrF-"};